function getTimeRemaining(dateString) {
  const now = new Date();
  const targetDate = new Date(dateString);

  if (isNaN(targetDate.getTime())) return null;

  const diffMs = targetDate - now;
  if (diffMs <= 0) return 'Expirado';

  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diffMs / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diffMs / (1000 * 60)) % 60);

  if (days > 0) return `${days} dias`;
  if (hours > 0) return `${hours} horas`;
  return `${minutes} minutos`;
}

function updateTimeRemaining(container = document) {
  const elements = container.querySelectorAll('.js-time-remaining');
  elements.forEach((el) => {
    const dateStr = el.getAttribute('data-date');
    if (!dateStr) return;
    const display = getTimeRemaining(dateStr);
    if (display) el.textContent = display;
  });
}

export { updateTimeRemaining };